// Route stub created by tools/gen_web_routes.py from contract/catalog/screens.json; owned by hand from here on (A4U7).
import { ids } from '@orca/api-client/testIds'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { PageHeader } from '../../../../components/ui/page-header'
import { MemberInvite } from '../../../../features/members/MemberInvite'
import { text } from '../../../../shared/routing/search'

export const Route = createFileRoute('/o/$orgSlug/people/invite')({
  staticData: { screenId: 'MemberInviteScreen', access: 'member.invite' },
  // The route key's query arguments (screens.json `args`), as the apps' LinkResolver reads them;
  // unknown keys are dropped.
  validateSearch: (search: Record<string, unknown>): { teamId?: string } => ({
    teamId: text(search.teamId),
  }),
  loader: ({ context: { membership } }) => ({ orgId: membership.orgId }),
  component: MemberInviteScreen,
})

function MemberInviteScreen() {
  const { t } = useTranslation()
  const { orgId } = Route.useLoaderData()
  const { teamId } = Route.useSearch()
  const { orgSlug } = Route.useParams()
  return (
    <main data-testid={ids.memberInvite.root} className="flex flex-col gap-(--stack-lg)">
      <PageHeader title={t('members.invite.title')} />
      <MemberInvite orgId={orgId} orgSlug={orgSlug} teamId={teamId} />
    </main>
  )
}
